export default "__VITE_ASSET__CHsF9wiI__"